<div class="line-items-container">
  <div class="header-row">
    <!-- <h3>Invoice Items</h3> -->
    <button mat-icon-button color="warn" *ngIf="hasAnyRuleSuggestions()" (click)="openRuleSuggestionsDialog()">
      <mat-icon>warning</mat-icon>
    </button>
  </div>

  <div class="warning-banner" *ngIf="isUsingDefaultRates">
    <mat-icon>warning</mat-icon>
    <p>No practice tariff rate selected. Using default rates - DISCOVERY HEALTH (NON-NETWORK).
      <a (click)="navigateToSettings()"> Create a new practice tariff rate </a>
    </p>
  </div>

  <div class="warning-banner" *ngIf="isPrivatePatient">
    <mat-icon>warning</mat-icon>
    <p>Private patient pricing: Medical scheme rates are not available for this patient and therefore shortfall
      calculations will not be accurate.</p>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Select Coding Bundle</mat-label>
    <mat-select [(ngModel)]="codingBundle" (selectionChange)="handleCodingBundleSelection($event.value)">
      <mat-option *ngFor="let code of codingBundles" [value]="code">
        {{code.label}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <app-code-search-selector class="full-width m-b-20" [searchType]="'both'"
    (codeSelected)="handleGlobalSearchSelection($event)" [patient]="patient">
  </app-code-search-selector>

  <!-- Drag and Drop Container for Physiotherapy Practices -->
  <div 
    cdkDropList 
    (cdkDropListDropped)="drop($event)"
    class="line-items-drop-list"
    [class.drag-enabled]="isPhysioPractice"
    [style.display]="showLineItems ? 'block' : 'none'">
    
    <div 
      cdkDrag 
      *ngFor="let item of lineItems.controls; let i = index" 
      [formGroup]="getFormGroup(i)"
      class="line-item"
      [class.draggable]="isPhysioPractice">
      
      <!-- First Row -->
      <div class="line-item-row">
        <mat-form-field appearance="outline">
          <mat-label>Service Date</mat-label>
          <input matInput [matDatepicker]="itemDatePicker" formControlName="date" placeholder="DD/MM/YYYY"
            (dateChange)="onDateChange($event.value, i)">
          <mat-datepicker-toggle matSuffix [for]="itemDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #itemDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="code-field">
          <mat-label>Code</mat-label>
          <input matInput formControlName="code" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="description-field">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description">
        </mat-form-field>

        <mat-form-field appearance="outline" class="quantity-field"
          *ngIf="getFormGroup(i).get('codeType')?.value !== 'procedure'">
          <mat-label>Qty</mat-label>
          <input matInput type="number" formControlName="quantity" min="0.01" step="0.01" (blur)="recalculatePrice(i)"
            [disabled]="!getFormGroup(i).get('code')?.value?.trim()">
          <span matSuffix *ngIf="getFormGroup(i).get('quantityUnit')?.value" class="quantity-unit-suffix p-r-10">
            {{ getFormGroup(i).get('quantityUnit')?.value }}
          </span>
        </mat-form-field>

        <div class="action-buttons">
          <button mat-icon-button color="primary" (click)="toggleExpandedFields(i)">
            <mat-icon>{{ expandedFields[i] ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="cloneLineItem(i)">
            <mat-icon>content_copy</mat-icon>
          </button>
          <!-- Drag Handle for Physiotherapy Practices -->
          <button *ngIf="isPhysioPractice" mat-icon-button cdkDragHandle class="drag-handle">
            <mat-icon>drag_indicator</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteLineItem(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    <!-- {{getFormGroup(i).get('units')?.value}} -->
    <!-- Second Row -->
    <div class="line-item-row" *ngIf="getFormGroup(i).get('code')?.value?.trim()">
      <mat-form-field appearance="outline"
        *ngIf="getFormGroup(i).get('codeType')?.value === 'procedure' && !getFormGroup(i).get('isModifierLine')?.value">
        <mat-label>Patient Scheme Rate</mat-label>
        <span matPrefix class="p-l-5 p-r-5">R</span>
        <input matInput type="number" formControlName="cusPrice" (blur)="recalculatePrice(i)" readonly>
        <mat-spinner *ngIf="loadingStates[i]" diameter="20" class="field-spinner"></mat-spinner>
      </mat-form-field>

      <mat-form-field appearance="outline"
        *ngIf="getFormGroup(i).get('codeType')?.value === 'procedure'">
        <mat-label>Doctor Tariff Rate</mat-label>
        <span matPrefix class="p-l-5 p-r-5">R</span>
        <input matInput type="number" formControlName="unitPrice" (blur)="recalculatePrice(i)">
        <mat-spinner *ngIf="loadingStates[i]" diameter="20" class="field-spinner"></mat-spinner>
      </mat-form-field>

      <mat-form-field appearance="outline"
        *ngIf="getFormGroup(i).get('codeType')?.value === 'procedure' && !getFormGroup(i).get('isModifierLine')?.value">
        <mat-label>Patient Shortfall</mat-label>
        <span matPrefix class="p-l-5 p-r-5">R</span>
        <input matInput type="number" [value]="calculateShortfall(i)" readonly>
        <mat-spinner *ngIf="loadingStates[i]" diameter="20" class="field-spinner"></mat-spinner>
      </mat-form-field>

      <mat-form-field appearance="outline"
        *ngIf="getFormGroup(i).get('codeType')?.value === 'consumable'">
        <mat-label>Unit Price</mat-label>
        <span matPrefix class="p-l-5 p-r-5">R</span>
        <input matInput type="number" formControlName="unitPrice" (blur)="recalculatePrice(i)">
        <mat-spinner *ngIf="loadingStates[i]" diameter="20" class="field-spinner"></mat-spinner>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Total Due</mat-label>
        <span matPrefix class="p-l-5 p-r-5">R</span>
        <input matInput type="number" [value]="getFormGroup(i).get('balance')?.value" readonly>
        <mat-spinner *ngIf="loadingStates[i]" diameter="20" class="field-spinner"></mat-spinner>
      </mat-form-field>

      <!-- Include 0201 Code checkbox for consumables -->
      <mat-checkbox *ngIf="getFormGroup(i).get('codeType')?.value === 'consumable'"
        formControlName="include0201Code"
        (change)="onInclude0201CodeChange(i)" class="m-t-10">
        Include 0201 code
      </mat-checkbox>

      <!-- Add warning icon if there are rule suggestions -->
      <button mat-icon-button *ngIf="getFormGroup(i).get('ruleSuggestions')?.value?.length > 0"
        matTooltip="Rules available for this line" color="warn" (click)="toggleExpandedFields(i)">
        <mat-icon>warning</mat-icon>
      </button>
    </div>

    <!-- Who the line is billed for, shown on every line as on the printed invoice. -->
    <div class="line-provider" *ngIf="getFormGroup(i).get('code')?.value?.trim() && lineProviderLabel(i)"
      [class.overridden]="getFormGroup(i).get('providerId')?.value">
      <mat-icon>person</mat-icon>
      <span>Provider: {{ lineProviderLabel(i) }}</span>
    </div>

    <!-- Expandable Additional Fields -->
    <div class="additional-fields" [class.expanded]="expandedFields[i]">
      <div class="additional-fields-row">
        <div class="additional-fields-column">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Discount</mat-label>
            <span matPrefix class="p-l-5 p-r-5"
              *ngIf="getFormGroup(i).get('discountType')?.value !== 'percentage'">R</span>
            <input matInput type="number" formControlName="discount" (blur)="recalculatePrice(i, true)" step="0.01"
              min="0">
            <button matTooltip="Toggle discount type" mat-icon-button matSuffix (click)="toggleDiscountType(i)"
              type="button">
              <mat-icon>{{ getFormGroup(i).get('discountType')?.value === 'percentage' ? 'percent' : 'attach_money'
                }}</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="additional-fields-column">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Rule Type Override</mat-label>
            <mat-select formControlName="ruleTypeOverride" (selectionChange)="onRuleTypeOverrideChange($event, i)">
              <mat-option [value]="null">Use Default ({{ ruleType }})</mat-option>
              <mat-option value="OH">Out of Hospital</mat-option>
              <mat-option value="IH">In Hospital</mat-option>
              <mat-option value="DC">Day Clinic</mat-option>
              <mat-option value="SCOPE_OH">Scope Out of Hospital</mat-option>
              <mat-option value="SCOPE_IH">Scope In Hospital</mat-option>
              <mat-option value="SCOPE_DC">Scope Day Clinic</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="additional-fields-row" *ngIf="providers.length > 1">
        <div class="additional-fields-column">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Provider for this line</mat-label>
            <mat-select formControlName="providerId">
              <mat-option [value]="null">Use Default ({{ documentProviderLabel || 'document provider' }})</mat-option>
              <mat-option *ngFor="let p of providers" [value]="p.userId">
                {{ p.title }} {{ p.name }} {{ p.surname }}<ng-container *ngIf="p.mpNumber"> ({{ p.mpNumber }})</ng-container>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="additional-fields-row">
        <div class="additional-fields-column">
          <app-procedure-code-selector #procedureCodeSelector
            (codesChanged)="handleLineItemModifierSelection($event, i)" [modifiersOnly]="true"
            [modifierTypes]="['Info', 'Reduce', 'Compound']" [pluralTitle]="'Line Item Modifiers'"
            [singularTitle]="'Line Item Modifier'" [patient]="patient"></app-procedure-code-selector>
        </div>

        <div class="additional-fields-column">
          <app-icd-code-selector [patientSex]="icdCodingSex" [patientAge]="icdCodingAge" [defaultOnsetDate]="icdDefaultOnsetDate" [initialCodes]="getIcdCodesForLineItem(i)"
            (codesChanged)="onIcdCodesChanged($event, i)" [isRequired]="false">
          </app-icd-code-selector>
        </div>
      </div>

      <!-- Time Override Fields (for physio practices or when applicable) -->
      <div class="additional-fields-row" *ngIf="isPhysioPractice || shouldShowTimeFields(getFormGroup(i).get('code')?.value)">
        <div class="additional-fields-column">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Start Time Override</mat-label>
            <input matInput formControlName="startTime" [ngxTimepicker]="startTimePicker" [format]="24"
              placeholder="HH:MM" (ngModelChange)="onTimeChange(i)">
            <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
              [preventOverlayClick]="false"></ngx-material-timepicker>
          </mat-form-field>
        </div>

        <div class="additional-fields-column">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>End Time Override</mat-label>
            <input matInput formControlName="endTime" [ngxTimepicker]="endTimePicker" [format]="24"
              placeholder="HH:MM" (ngModelChange)="onTimeChange(i)">
            <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
              [preventOverlayClick]="false"></ngx-material-timepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Add Rule Suggestions Section -->
      <div class="rule-suggestions" *ngIf="getFormGroup(i).get('ruleSuggestions')?.value?.length > 0">
        <h4>Suggested Rules</h4>
        <div class="rule-suggestion" *ngFor="let suggestion of getFormGroup(i).get('ruleSuggestions')?.value">
          <div class="rule-info">
            <p class="rule-message">{{suggestion.message}}</p>
            <!--  <p class="rule-code">{{suggestion.ruleCode}}: </p> -->
            <p class="rule-description">{{suggestion.ruleDescription}}</p>
            <button mat-raised-button color="primary" (click)="applyModiferRule(suggestion, i)">
              <mat-icon>check_circle</mat-icon>
              Apply Rule
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="add-item-button" *ngIf="showLineItems">
    <button mat-raised-button color="primary" (click)="addLineItem()">
      <mat-icon>add</mat-icon>
      Add Manual Item
    </button>
  </div> -->
  </div> <!-- Close cdkDropList -->
</div>
<br>

<!-- Remove the duplicate financial summary table -->
<ng-template #contactDialog>
  <h1 mat-dialog-title>Contact Us</h1>
  <div mat-dialog-content>
    <div class="p-t-20 field-column">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Title</mat-label>
        <mat-select [(ngModel)]="contactMessage.title" required>
          <mat-option *ngFor="let title of titles" [value]="title.value">
            {{ title.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="contactMessage.name" placeholder="Name" type="text" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Surname</mat-label>
        <input matInput [(ngModel)]="contactMessage.surname" placeholder="Surname" type="text" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="contactMessage.email" placeholder="Email" type="email" required>
      </mat-form-field>
      <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="contactMessage.contactNumber"
        placeholder="Contact Number" (valueChange)="contactMessage.contactNumber = $event" name="contactNumber"
        classList="full-width"></app-intl-phone-input>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Message</mat-label>
        <textarea matInput [(ngModel)]="contactMessage.message" rows="4" required></textarea>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="sendContactMessage()">Send</button>
  </div>

</ng-template>

<!-- Add the new dialog template at the end of the file -->
<ng-template #ruleSuggestionsDialog>
  <h2 mat-dialog-title>Rule Suggestions</h2>
  <mat-dialog-content>
    <div class="rule-suggestions-list">
      <div *ngFor="let item of getAllRuleSuggestions()" class="rule-suggestion-item">
        <div class="code-info">
          <strong>{{item.code}}</strong>
          <span class="description">{{item.description}}</span>
        </div>
        <div class="suggestions">
          <div *ngFor="let suggestion of item.suggestions" class="suggestion">
            <p class="message">{{suggestion.message}}</p>
            <p class="description">{{suggestion.ruleDescription}}</p>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ignore</button>
    <button mat-raised-button color="primary" (click)="applyAllRuleSuggestions()">Apply All</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #priceOverrideSelectionDialog>
  <h1 mat-dialog-title>Select Price Override</h1>
  <div mat-dialog-content>
    <p class="hint">Multiple price overrides found for procedure code
      <strong>{{matchingPriceOverrides[0].code}}</strong>. Please select
      the appropriate one:
    </p>
    <mat-radio-group [(ngModel)]="selectedPriceOverride">
      <mat-radio-button *ngFor="let override of matchingPriceOverrides" [value]="override" class="d-block m-b-10">
        <div class="price-override-option">
          <span class="price">R{{ override.priceOverride }}</span>
          <span class="description" *ngIf="override.overrideDescription">{{ override.overrideDescription }}</span>
          <span class="appointment-type" *ngIf="override.appointmentTypeId">
            ({{ override.appointmentType.type }})
          </span>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="confirmPriceOverrideSelection()">Select</button>
    <button mat-raised-button (click)="cancelPriceOverrideSelection()">Cancel</button>
  </div>
</ng-template>

<!-- Time Dialog Template -->
<ng-template #codeTimeDialog>
  <h1 mat-dialog-title>Start/Finish Time Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Start Time</mat-label>
        <input matInput [(ngModel)]="timeAdditionalInfo.startTime" [ngxTimepicker]="startTimePicker" [format]="24"
          required>
        <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>End Time</mat-label>
        <input matInput [(ngModel)]="timeAdditionalInfo.endTime" [ngxTimepicker]="endTimePicker" [format]="24" required>
        <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="timeAdditionalInfo"
      [disabled]="!timeAdditionalInfo.startTime || !timeAdditionalInfo.endTime">Save</button>
  </div>
</ng-template>

<!-- Surgical Assistant Dialog Template -->
<ng-template #codeAssistantDialog>
  <h1 mat-dialog-title>Surgical Assistant Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Assistant Name</mat-label>
        <input matInput [(ngModel)]="assistantAdditionalInfo.assistantName"
          (ngModelChange)="filterAssistants($event)" [matAutocomplete]="assistantAuto">
        <mat-autocomplete #assistantAuto="matAutocomplete" (optionSelected)="onAssistantSelected($event.option.value)">
          <mat-option *ngFor="let assistant of filteredAssistants" [value]="assistant.name">
            {{ assistant.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Practice Number</mat-label>
        <input matInput [(ngModel)]="assistantAdditionalInfo.assistantPracticeNumber">
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="assistantAdditionalInfo">Save</button>
  </div>
</ng-template>

<!-- BMI Dialog Template -->
<ng-template #codeBMIDialog>
  <h1 mat-dialog-title>BMI Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Weight</mat-label>
        <input matInput [(ngModel)]="bmiAdditionalInfo.weight" (input)="calculateBMI()" required>
        <span matSuffix>&nbsp; kg&nbsp;</span>
      </mat-form-field>
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Height</mat-label>
        <input matInput [(ngModel)]="bmiAdditionalInfo.height" (input)="calculateBMI()" required>
        <span matSuffix>&nbsp; cm&nbsp;</span>
      </mat-form-field>
    </div>
    <p *ngIf="bmiAdditionalInfo.BMI">Calculated BMI: {{bmiAdditionalInfo.BMI}}</p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [mat-dialog-close]="bmiAdditionalInfo">Save</button>
  </div>
</ng-template>